import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import SuccessMsg from "../../Messages/SuccessMsg";
import { ExpenseInterface, DefaultExpenseInterface, ShowExpenseContext } from "./types";
import { getExpensesApi } from "../../redux/expense/expenseApiCalls";
import EditExpense from "./EditExpense";
import DeleteExpense from "./DeleteExpense";
import AddNewExpense from "./AddNewExpense";
import DataExpenses from "./DataExpenses";
import FilterExpenses from "./FilterExpenses";

const ShowExpenses = () => {
  const [showSuccessMsg, setShowSuccessMsg] = useState<boolean>(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [selectedExpense, setSelectedExpense] = useState<ExpenseInterface>(DefaultExpenseInterface);

  const [startDate, setStartDate] = useState(new Date())
  const [endDate, setEndDate] = useState(new Date(new Date().setDate(new Date().getDate() + 1))) // tomorrow

  const [day, setDay] = useState(new Date().getDate())  
  const [month, setMonth] = useState(new Date().getMonth() + 1)  
  const [year, setYear] = useState(new Date().getFullYear())  
  const [showSwitchDate, setShowSwitchDate] = useState(false)
  const [selectedDate, setSelectedDate] = useState<Date>(new Date())
  

  useEffect(() => {
    const createDate = new Date()
    day.toString() !== "jour" && createDate.setDate(day)
    month.toString() !== "mois" && createDate.setMonth(month - 1)
    createDate.setFullYear(year)
    setSelectedDate(createDate)
  }, [day, month, year])

  const dispatch: any = useDispatch();

  useEffect(() => {
    const fetchData = async () => {
      await dispatch(getExpensesApi());
    };
    fetchData();
  }, [dispatch]);


  return (
    <ShowExpenseContext.Provider value={{
      showSuccessMsg, setShowSuccessMsg,
      showEditModal, setShowEditModal,
      showDeleteModal, setShowDeleteModal,
      selectedExpense, setSelectedExpense,
      startDate, setStartDate,
      endDate, setEndDate,
      day, setDay,
      month, setMonth,
      year, setYear,
      showSwitchDate, setShowSwitchDate,
      selectedDate, setSelectedDate,
    }}>
      {showSuccessMsg && (
        <SuccessMsg
          modal={showSuccessMsg}
          toggle={() => setShowSuccessMsg(!showSuccessMsg)}
        />
      )}
      
      <AddNewExpense />
      <FilterExpenses />
      <DataExpenses />
      {showEditModal && 
        <EditExpense 
          modal={showEditModal}
          toggle={() => setShowEditModal(!showEditModal)}
          selectedExpense={selectedExpense} 
        />}
      {showDeleteModal && 
        <DeleteExpense 
          modal={showDeleteModal}
          toggle={() => setShowDeleteModal(!showDeleteModal)}
          selectedExpense={selectedExpense} 
        />
      }

    </ShowExpenseContext.Provider>
  );
};

export default ShowExpenses;
